import { createContext } from 'react';

import { createStore, Store } from '../../../../../core/store/store.js';
import { initialState } from '../providers/AnnotationsDataInitialState.js';
import type { AnnotationState } from '../types/state.js';

export const AnnotationsStateContext = createContext<Store<AnnotationState>>(
  createStore<AnnotationState>(initialState),
);

AnnotationsStateContext['displayName'] = 'AnnotationsStateContext';
